import { render, staticRenderFns } from "./EditPrivacy.page.vue?vue&type=template&id=db072f8e&"
import script from "./EditPrivacy.page.vue?vue&type=script&lang=js&"
export * from "./EditPrivacy.page.vue?vue&type=script&lang=js&"
import style0 from "./EditPrivacy.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports